import { all, fork, put, takeEvery } from 'redux-saga/effects';
import callToAPI from '../../../utils/callToAPI';
import * as Api from '../../api/prms';
import * as types from './types';

function* deletePRM({ payload }) {
  yield callToAPI({
    apiCall: Api.deletePRM,
    successResponseCode: 200,
    errorType: types.DELETE_PRM_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_PRM_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

function* getPRMs({ payload }) {
  yield callToAPI({
    apiCall: Api.getPRMs,
    successResponseCode: 200,
    errorType: types.GET_PRMS_ERROR,
    *callback({ data: { data, total } }) {
      yield put({
        type: types.GET_PRMS_SUCCESS,
        payload: {
          data: data,
          total: total,
        },
      });
    },
    payload,
  });
}

function* watcherDeletePRM() {
  yield takeEvery(types.DELETE_PRM_REQUEST, deletePRM);
}
function* watcherGetPRMs() {
  yield takeEvery(types.GET_PRMS_REQUEST, getPRMs);
}

export default function* rootSaga() {
  yield all([fork(watcherGetPRMs), fork(watcherDeletePRM)]);
}
